


export function Details(props: { children: preact.ComponentChildren }) {
  return <details>
    {props.children}
  </details>
}

export function Summary(props: { children: preact.ComponentChildren }) {
  return <summary>
    <span>{props.children}</span>
    <a class="button">Details</a>
  </summary>
}

export function Content(props: { children: preact.ComponentChildren }) {
  return <div class="content"> {props.children} </div>
}